import { useAuthStore } from '../../stores/authStore';
import { getThemeStringValueByName } from '../../utilities/styling/UseCssVarByName';
import { getOrCreateAnalytics } from '../../utils/analytics';
import { checkIfHasPermission } from '../user-permissions/HasPermission';
import { PopoverContent } from './PopoverContent';
import { ReactComponent as AppsIcon } from './icons/AppsIcon.svg';
import styled from '@emotion/styled';
import { Popover } from 'antd';
import { observer } from 'mobx-react-lite';

interface AppsMenuProps {
	readonly selectedPage: 'quality' | 'patient-portrait' | 'dashboard' | 'admin' | 'files';
}

const StyledButton = styled.div`
	display: inline-flex;
	gap: 8px;
	align-items: center;
	justify-content: center;
	color: ${getThemeStringValueByName('purple.3')};
	border-radius: 6px;
	padding: 8px;
	transition:
		background-color 0.1s,
		color 0.1s;

	&:hover {
		background-color: ${getThemeStringValueByName('purple.6')};
		color: ${getThemeStringValueByName('purple.1')};
	}
`;

export const AppsMenu = observer(function AppsMenu({ selectedPage }: AppsMenuProps) {
	const authStore = useAuthStore();
	const hasQualityPermission = checkIfHasPermission(authStore, 'quality_tool', false);
	const hasDashboardPermission = checkIfHasPermission(authStore, 'hcc_dashboard', false);
	const hasFileManagerPermission = checkIfHasPermission(authStore, 'files_manager', false);
	const hasAdminToolPermission = checkIfHasPermission(authStore, 'admin_tool', false);

	if (
		!authStore.isAdmin &&
		!hasQualityPermission &&
		!hasDashboardPermission &&
		!hasFileManagerPermission &&
		!hasAdminToolPermission
	) {
		console.log('No permissions to show any apps menu items', { permissions: authStore?.permissions });
		return null;
	}

	const onHoverAnalytic = (): Promise<void> =>
		getOrCreateAnalytics().track(getOrCreateAnalytics().idsNames.SummaryClick, {
			actionId: 'AppMenuHover',
			SourcePage: selectedPage,
		});

	return (
		<Popover
			{...{
				placement: 'bottomLeft',
				content: <PopoverContent selectedPage={selectedPage} />,
				trigger: 'hover',
				styles: { root: { inlineSize: 330 }, body: { padding: 0 } },
			}}
		>
			<StyledButton onMouseEnter={onHoverAnalytic}>
				<AppsIcon />
			</StyledButton>
		</Popover>
	);
});
